export default __webpack_public_path__ + "static/media/skull.faedc240.gif";